import { SystemStyleObject } from '@chakra-ui/react'

import type { ColorScheme } from '../../types'

const tokens = {
  dark: {
    rowHover: 'bg.table-row-hover',
    titleColor: 'text.primary',
    divider: 'border.subtle',
  },
  light: {
    rowHover: 'light.bg.table-row-hover',
    titleColor: 'light.text.primary',
    divider: 'light.border.subtle',
  },
} as const

export const activeIncidentCardStyles = (
  colorScheme: ColorScheme = 'dark',
  showDivider = true
): SystemStyleObject => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  px: '12px',
  py: '12px',
  w: 'full',
  transition: 'background-color 0.2s ease',
  _hover: { bg: tokens[colorScheme].rowHover },
  // A bottom border pins the row separator to the item's bottom edge — robust
  // to the fixed-height virtualised slot, where a child divider would float
  // under the content instead.
  ...(showDivider && {
    borderBottom: '1px solid',
    borderColor: tokens[colorScheme].divider,
  }),
})

export const activeIncidentCardBodyStyles: SystemStyleObject = {
  display: 'grid',
  gridTemplateColumns: '24px 1fr',
  gap: '12px',
  alignItems: 'flex-start',
  w: 'full',
}

export const activeIncidentCardIconStyles: SystemStyleObject = {
  alignItems: 'center',
  boxSize: '24px',
  display: 'flex',
  flexShrink: 0,
  justifyContent: 'center',
  overflow: 'hidden',
  // Dark icons ship inconsistent default sizes (CameraIcon 12, DoorIcon 17,
  // Alarm/Manual 20), so normalise every glyph to 20px — matching how
  // IncidentCard's detection-icon slot renders. preserveAspectRatio keeps
  // non-square viewBoxes (e.g. the camera) from distorting.
  '& svg': { width: '20px', height: '20px' },
}

export const activeIncidentCardContentStyles: SystemStyleObject = {
  display: 'flex',
  flexDirection: 'column',
  gap: '6px',
  minWidth: 0,
}

export const activeIncidentCardTitleStyles = (
  colorScheme: ColorScheme = 'dark'
): SystemStyleObject => ({
  fontFamily: "'Soehne Kraftig', sans-serif",
  fontStyle: 'normal',
  fontWeight: 500,
  fontSize: '14px',
  lineHeight: '20px',
  color: tokens[colorScheme].titleColor,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  minWidth: 0,
  margin: 0,
})
